import { Theme } from "@mui/material";

const transparentToGreyDividerStyle = {
  divider: (theme: Theme) => ({
    ...(theme.palette.mode === "dark"
      ? {
          display: "none",
        }
      : {
          width: "100%",
          overflow: "hidden",
          transform: "rotate(180deg)",
        }),
  }),
  svg: (theme: Theme) => ({
    position: "relative",
    display: "block",
    width: "calc(129% + 1.3px)",
    height: "73px",
    "& path": {
      fill: theme.palette.background.light,
    },
  }),
};

export default transparentToGreyDividerStyle;
